import { useMutation } from '@tanstack/react-query';
import { gravarAgendamentoApi } from '../api/GravarAgendamentoApi';
import type { GravarAgendamentoPayload } from '../types';

export function useGravarAgendamento() {
  return useMutation<void, Error, GravarAgendamentoPayload>({
    mutationFn: gravarAgendamentoApi,
  });
}
